const types = {
  SET_SITES: 'SET_SITES',
  CLEAR_SITES: 'CLEAR_SITES',
  SET_ACTIVE_SITE: 'SET_ACTIVE_SITE',
  CLEAR_ACTIVE_SITE: 'CLEAR_ACTIVE_SITE',
}

export default types
